
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/history/[year]/[month]/[day]",
      function () {
        return require("private-next-pages/history/[year]/[month]/[day]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/history/[year]/[month]/[day]"])
      });
    }
  